// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".address-autocomplete-lookup__inner[data-v-a8188db2]{padding:0 4px;margin-bottom:4px}.manual-btn-wrapper[data-v-a8188db2]{margin-top:-28px;margin-bottom:8px;display:flex;justify-content:flex-end;width:100%;padding:0 12px}.manual-btn[data-v-a8188db2]{cursor:pointer;display:flex;align-items:center;gap:4px;z-index:9;font-size:13px;font-weight:500;color:#36134a;transition:color .15s}.manual-btn[data-v-a8188db2]:hover{color:#9d76a7}", ""]);
// Exports
module.exports = exports;
